module.exports = __webpack_public_path__ + "static/media/carpenter.30b7ca84.svg";